// Photo par code produit. Un produit sans photo (orge, goyave, corossol, pomme de cajou,
// concombre, aubergine...) prend l'image de sa sous-catégorie : voir utils/getProductImage.
const PRODUCT_IMAGES = {

    // =========================
    // CEREALS
    // =========================

    RICE:
        "/images/product-images/cereals/rice/rice-1.jpeg",

    MAIZE:
        "/images/product-images/cereals/maize/maize-1.jpeg",

    WHEAT:
        "/images/product-images/cereals/wheat/wheat-1.jpeg",


    SORGHUM:
        "/images/product-images/cereals/sorghum/sorghum-1.jpeg",

    MILLET:
        "/images/product-images/cereals/millet/millet-1.jpeg",

    // =========================
    // LEGUMES
    // =========================

    BEAN:
        "/images/product-images/legumes/bean/bean-1.jpeg",

    CHICKPEA:
        "/images/product-images/legumes/chickpea/chickpea-1.jpeg",

    COWPEA:
        "/images/product-images/legumes/cowpea/cowpea-1.jpeg",

    LENTIL:
        "/images/product-images/legumes/lentil/lentil-1.jpeg",

    SOYBEAN:
        "/images/product-images/legumes/soybean/soybean-1.jpeg",

    PEANUT:
        "/images/product-images/legumes/peanut/peanut-1.png",

    // =========================
    // TUBERS
    // =========================

    CASSAVA:
        "/images/product-images/tubers/cassava/cassava-1.jpeg",

    YAM:
        "/images/product-images/tubers/yam/yam-1.jpeg",

    POTATO:
        "/images/product-images/tubers/potato/potato-1.jpeg",

    SWEET_POTATO:
        "/images/product-images/tubers/sweet-potato/sweet-potato-1.jpeg",

    TARO:
        "/images/product-images/tubers/taro/taro-1.jpeg",

    // =========================
    // SPICES
    // =========================

    GINGER:
        "/images/product-images/spices/ginger/ginger-1.jpeg",

    PEPPER:
        "/images/product-images/spices/black-pepper/black-pepper-2.jpeg",

    BELL_PEPPER:
        "/images/product-images/spices/bell-pepper/bell-pepper-1.jpeg",

    CHILI_PEPPER:
        "/images/product-images/spices/chili-pepper/chili-pepper-1.jpeg",

    BLACK_PEPPER:
        "/images/product-images/spices/black-pepper/black-pepper-1.jpeg",

    // Code stocké par le semis : TUMERIC (sic).
    TUMERIC:
        "/images/product-images/spices/tumeric/tumeric-1.jpeg",

    TURMERIC:
        "/images/product-images/spices/tumeric/tumeric-1.jpeg",

    CLOVE:
        "/images/product-images/spices/black-pepper/black-pepper-1.jpeg",

    VANILLA:
        "/images/product-images/spices/vanilla/vanilla-1.png",


    // =========================
    // FRUITS
    // =========================

    MANGO:
        "/images/product-images/fruits/mango/mango-1.jpeg",

    ORANGE:
        "/images/product-images/fruits/orange/orange-1.jpeg",

    BANANA:
        "/images/product-images/fruits/banana/banana-1.jpeg",

    PINEAPPLE:
        "/images/product-images/fruits/pineapple/pineaaple-1.jpeg",

    PAPAYA:
        "/images/product-images/fruits/papaya/papaya-1.jpeg",

    AVOCADO:
        "/images/product-images/fruits/avocado/avocado-1.jpeg",




    // =========================
    // VEGETABLES
    // =========================

    TOMATO:
        "/images/product-images/vegetables/tomato/tomato-1.jpeg",

    ONION:
        "/images/product-images/vegetables/onion/onion-1.jpeg",

    CARROT:
        "/images/product-images/vegetables/carrot/carrot-1.jpeg",

    CABBAGE:
        "/images/product-images/vegetables/cabbage/cabbage-1.jpeg",




    // =========================
    // HERBS
    // =========================

    MORINGA:
        "/images/product-images/herbs/moringa/moringa-1.jpeg",

    MINT:
        "/images/product-images/herbs/mint/mint-1.jpeg",

    ARTEMISIA:
        "/images/product-images/herbs/artemisia/artemisia-1.jpeg",

    HIBISCUS:
        "/images/product-images/herbs/hibiscus/hibiscus-1.jpeg",

    NEEM:
        "/images/product-images/herbs/neem/neem-1.jpeg",

    LEMONGRASS:
        "/images/product-images/herbs/lemongrass/lemongrass-1.jpeg",


    // =========================
    // FLOWERS
    // =========================

    BOUGAINVILLEA:
        "/images/product-images/flowers/bougainvillea/Bougainvillea-1.jpeg",

    HIBISCUS_FLOWER:
        "/images/product-images/flowers/hibiscus-flower/hibiscus-flower-1.jpeg",

    MARIGOLD:
        "/images/product-images/flowers/marigold/marigold-1.jpeg",

    ORCHID:
        "/images/product-images/flowers/orchid/orchid-1.jpeg",

    ROSE:
        "/images/product-images/flowers/rose/rose-1.jpeg",

    SUNFLOWER:
        "/images/product-images/flowers/sunflower/sunflower-1.jpeg",


    // =========================
    // DEFAULT
    // =========================

    DEFAULT:
        "/images/product-images/cereals/cereal-1.jpeg"
};

export default PRODUCT_IMAGES;